import React, { useEffect, useState } from 'react';
import { useLazyEArchiveWorkplacePatientsQuery } from '../../../../graphql/graphql';
import useWorkplacePatients from '../../Hooks/useWorkplacePatients';
import useFlatData from '../../../Base/Hooks/useFlatData';
// @ts-ignore
import styles from './EArchiveList.module.scss';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import EArchiveListItem from './EArchiveListItem/EArchiveListItem';
import { View } from '../../../../Enums/View.enum';
import EArchiveToolbar from './EArchiveToolbar/EArchiveToolbar';
import EArchiveListFilter from './EArchiveListFilter/EArchiveListFilter';
import { useAppContext } from '../../../../Services/AppContext';

const WRAPPER_ID = 'eArchiveWrapper';

const EArchiveList: React.FC = () => {
	const [view, setView] = useState(View.GRID);
	const [getWorkplacePatientsQuery, { data, isLoading }] =
		useLazyEArchiveWorkplacePatientsQuery();
	const { getWorkplacePatients, getNextPage, page, setPage } =
		useWorkplacePatients(getWorkplacePatientsQuery);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplacePatients,
		{
			data: data?.workplacePatients?.data,
			totalPages: data?.workplacePatients?.meta?.totalPages,
			page: data?.workplacePatients?.meta?.page,
		},
		page,
		setPage,
	);

	// @ts-ignore
	const { socket } = useAppContext();

	useEffect(() => {
		socket.on('refreshEArchive', loadData);
		return () => {
			socket.off('refreshEArchive', loadData);
		};
	}, []);

	return (
		<div className={styles.wrapper}>
			<EArchiveListFilter onFilter={setFilter} />
			<EArchiveToolbar
				itemsCount={data?.workplacePatients?.meta?.count ?? 0}
				onViewChange={setView}
				activeView={view}
				reloadData={loadData}
			/>
			<ScrollContainer wrapperId={WRAPPER_ID} className={styles.background}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey='id'
					className={styles[view]}
					renderItem={item => (
						<EArchiveListItem item={item} onRefresh={loadData} view={view} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default EArchiveList;
